module.exports = __webpack_public_path__ + "img/s2-hx-5.d5a85afa.png";